<template>
	<div>
		<box :ref="boxRef" title="自动匹配" :width="1000" :index="4" moduleName="goods" @hide="hide" @submit="submit"
			group="purchase_goods" :pagerConfig="pagerConfig" :store="store" selectType="checkbox"
			@boxdataload="boxdataload" />
	</div>
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	//https://detail.tmall.com/item.htm?id=706822484836&spm=a21dvs.23580594.0.0.1d293d0d88sla5 
	import box from '@_system/components/formcomponents/common/box/index.vue'
	//import phonebox from '@_system/components/formcomponents/phone/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			policyId: {
				default: () => {
					return null
				}
			},


		},
		data() {
			return {
				index: 0,
				foreingKey: {},
				boxRef: 'box_' + Math.random(),
				box: null,
				pagerConfig: {
					currentPage : 1,
					pageSize : 20,
					total : 0,
					pageSizes : [10, 20, 50, 100, 200, 500, 1000, 2000],
					enabled : true,
					force:true
				},
			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			box.pagerConfig = this.pagerConfig
			//box.list = this.list
			// box.checkMethod = this.checkMethod
			// box.toolbarButtonClickEvent = this.toolbarButtonClickEvent
			// box.beforeRequest = this.beforeRequest
			// box.pagerConfig = {
			// 	currentPage: -1,
			// 	enabled: false,
			// 	force:true
			// }
			box.setForeingKey({
				policyId: this.policyId
			})
			this.box = box

			// if (this.store.box) {
			// 	this.store.box.saleorder = this
			// } else {
			// 	let obj = {}
			// 	obj.saleorder = this
			// 	this.store.box = obj
			// }


		},
		watch: {
			policyId(val) {
				if (val) {
					this.box.setForeingKey({
						policyId: val
					})
				}
			}
		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			// beforeRequest(form) {
			// 	if (form.onlineid) {
			// 		let id = this.checkUrl(form.onlineid)
			// 		if (id) {
			// 			form.onlineid = id
			// 		}
			// 	}
			// },
			// checkMethod({
			// 	row
			// }) {
			// 	return row.isparent === 1 && row.childrennum > 0 || row.isparent !== 1
			// },
			submit(e) {
				this.$emit('submit', e)
			},
			// toolbarButtonClickEvent(e) {
			// 	if (e.code == 'pull') {

			// 		let code = this.box.getTable().getCheckboxRecords()
			// 		let codes = []
			// 		code.forEach((item) => {
			// 			codes.push(item.groupcode)
			// 		})
			// 		let uniqueCodes = codes.filter((item, index) => {
			// 			return codes.indexOf(item) === index
			// 		})
			// 		if (uniqueCodes.length != 0) {
			// 			if (uniqueCodes.length == 1) {
			// 				e.button.disabled = true
			// 				e.button.icon = 'el-icon-loading'
			// 				this.$api.goodsonline.pull({
			// 					codes: uniqueCodes.join(',')
			// 				}).then(() => {
			// 					e.button.disabled = false
			// 					e.button.icon = ''
			// 					this.box.getTable().commitProxy('query')
			// 				}, () => {
			// 					e.button.disabled = false
			// 					e.button.icon = ''
			// 					this.$message.error('万里牛超时接口超时，同步失败')
			// 				})
			// 			} else {
			// 				this.$message.error('一次只能同步一个')
			// 			}
			// 		} else {

			// 			this.$message.error('请选择组合编码')
			// 		}

			// 	}

			// },
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box,
			//phonebox
		}
	}
</script>
